import type { FunctionComponent } from "react";
import type { Credit } from "@kanda-libs/ks-frontend-services";
import Link from "components/shared/Link";
import { Price, Tag, Text } from "@kanda-libs/ks-design-library";
import usePaymentProps from "components/job/JobLayout/JobPayments/Payment/usePaymentProps";
import type { PaymentWithFinanceType } from "./types";

export interface PaymentProps {
  payment: PaymentWithFinanceType;
  credits: Credit[];
}

const Payment: FunctionComponent<PaymentProps> = function ({ payment }) {
  const { id, status, total, method, createdAt, wrapperProps } =
    usePaymentProps(payment);

  return (
    <Link
      {...wrapperProps}
      className="flex flex-col px-5 py-4 mb-2 border rounded-lg border-neutral-300 last:mb-0 shadow-card"
    >
      <>
        <div className="flex flex-row">
          <Text
            text="Payment ID:"
            skeletonClassName="min-w-24"
            className="text-14-22-em min-w-24"
          />
          <Text
            text={id}
            className="ml-2 text-14-22"
            skeletonProps={{ width: "100px" }}
          />
        </div>
        <div className="flex flex-row">
          <Text
            text="Created At:"
            skeletonClassName="min-w-24"
            className="text-14-22-em min-w-24"
          />
          <Text
            text={createdAt?.date}
            className="ml-2 text-14-22"
            skeletonProps={{ width: "100px" }}
          />
          <Text
            text={createdAt?.time}
            className="ml-2 text-14-22"
            skeletonProps={{ width: "100px" }}
          />
        </div>
        <div className="flex flex-row">
          <Text
            text="Status:"
            skeletonClassName="min-w-24"
            className="text-14-22-em min-w-24"
          />
          <Text
            text={status}
            className="ml-2 text-14-22"
            skeletonProps={{ width: "100px" }}
          />
        </div>
        <div className="flex flex-row">
          <Text
            text="Method:"
            skeletonClassName="min-w-24"
            className="text-14-22-em min-w-24"
          />
          <Text
            text={method}
            className="ml-2 text-14-22"
            skeletonProps={{ width: "100px" }}
          />
        </div>
        <div className="flex flex-row">
          <Text
            text="Status:"
            skeletonClassName="min-w-24"
            className="text-14-22-em min-w-24"
          />
          <Price
            amount={total}
            color="neutral-900"
            poundsClassName="text-14-22"
            centsClassName="text-14-22"
            wrapperClassName="ml-2"
          />
        </div>
        <div className="flex flex-row">
          <Text
            text="Finance Types:"
            skeletonClassName="min-w-24"
            className="mr-2 text-14-22-em min-w-24"
          />
          <Tag
            label={payment.finance_type}
            color={payment.finance_type === "secondary" ? "lavender" : "grey"}
          />
        </div>
      </>
    </Link>
  );
};

export default Payment;
